import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-8 text-center shadow-inner mt-auto">
      <div className="container mx-auto px-4">
        <p className="text-sm mb-2">
          &copy; {new Date().getFullYear()} Celerity Technocrats. All rights reserved.
        </p>
        <p className="text-xs">
          Innovating with Celerity. Delivering excellence, on time, every time.
        </p>
        <div className="flex justify-center space-x-4 mt-4 text-lg">
          {/* Example Social Icons - Replace with actual icons/links if needed */}
          <a href="https://www.linkedin.com/in/celerity-technocrats-29879696/" className="hover:text-blue-400 transition-colors duration-300" aria-label="LinkedIn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
          </a>
          <a href="https://www.facebook.com/celerity.technocrats.5" className="hover:text-blue-400 transition-colors duration-300" aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="24" width="24" version="1.1" viewBox="-337 273 123.5 256"><path d="M-260.9,327.8c0-10.3,9.2-14,19.5-14c10.3,0,21.3,3.2,21.3,3.2l6.6-39.2c0,0-14-4.8-47.4-4.8c-20.5,0-32.4,7.8-41.1,19.3 c-8.2,10.9-8.5,28.4-8.5,39.7v25.7H-337V396h26.5v133h49.6V396h39.3l2.9-38.3h-42.2V327.8z"/></svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

// import React from "react";

// const Footer = () => {
//   return (
//     <section className="footer_section">
//       <div className="container">
//         <p>
//           &copy; <span id="displayYear"></span> All Rights Reserved By
//           <a href="https://celeritytechnocrats.com/"> Celerity Technocrats</a>
//         </p>
//       </div>
//     </section>
//   );
// };

// export default Footer;
